import React from "react";
import Constants from "../../../constants/Index";
import { LegendRounded } from "../LegendRounded/Index";
import { ButtonWithChildren } from "../../Buttons/ButtonWithChildren/Index";

type ManagementLegendProps = {
  view: "type" | "height" | "rate" | "day";
  maxValueOnGradiente: number;
  maxOcupacao: number;
  maxDescanso: number;
  rateSelected: number;
  onRateChange: (rate: number) => void;
};

export function ManagementLegend({ 
  view, 
  maxValueOnGradiente, 
  maxOcupacao, 
  maxDescanso, 
  rateSelected, 
  onRateChange 
}: ManagementLegendProps) {
  
  const formatNumber = (num: number) => {
    return num % 1 === 0 ? num.toString() : num.toFixed(2);
  };
  
  if (view === "type") {
    return (
      <section className="pasturemanagement__footerlegend--container">
        <h6>Manejo</h6>
        <div className="pasturemanagement__footerlegend--content">
          <LegendRounded label="Contínuo" bgColor={Constants.PASTUREMANAGEMENT_COLORS.ORANGE} />
          <LegendRounded label="Rotacionado" bgColor={Constants.PASTUREMANAGEMENT_COLORS.RED} />
          <LegendRounded label="Em faixa" bgColor={Constants.PASTUREMANAGEMENT_COLORS.BLUE} />
          <LegendRounded label="Sem monitoramento" bgColor={Constants.PASTUREMANAGEMENT_COLORS.WHITE} />
        </div>
      </section>
    );
  }

  if (view === "height") {
    return (
      <section className="pasturemanagement__footerlegend--container">
        {maxValueOnGradiente !== 0 && (
          <>
            <h6>Altura</h6>
            <div className="pasturemanagement__footerlegend--content">
              <div>
                <div className="pasturemanagement--bar" />
                <div className="pasturemanagement--containerlegend">
                  <span>0</span>
                  <span>{formatNumber(Number(maxValueOnGradiente))}</span>
                </div>
              </div>
            </div>
            <br />
          </>
        )}
        <div className="pasturemanagement__footerlegend--content">
          <LegendRounded label="Acima da altura" bgColor={Constants.PASTUREMANAGEMENT_COLORS.GREEN} />
          <LegendRounded label="Dentro do intervalo" bgColor={Constants.PASTUREMANAGEMENT_COLORS.CYAN} />
          <LegendRounded label="Abaixo da altura" bgColor={Constants.PASTUREMANAGEMENT_COLORS.RED} />
          <LegendRounded label="Sem altura atribuida" bgColor={Constants.PASTUREMANAGEMENT_COLORS.YELLOW} />
        </div>
      </section>
    );
  }

  if (view === "rate") {
    return (
      <>
        {maxValueOnGradiente !== 0 && (
          <section className="filterpolygons__container pasturemanagement__toplegend--container">
            <h6>Seleção de nota de referência</h6>
            <div>
              <ButtonWithChildren 
                theme={rateSelected === 0 ? "info" : "dark"} 
                onClick={() => onRateChange(0)}
              >
                0 a 5
              </ButtonWithChildren>
              <ButtonWithChildren 
                theme={rateSelected === 1 ? "info" : "dark"} 
                onClick={() => onRateChange(1)}
              >
                0 a 10
              </ButtonWithChildren>
            </div>
          </section>
        )}

        <section className="pasturemanagement__footerlegend--container">
          {maxValueOnGradiente !== 0 && (
            <>
              <h6>Nota</h6>
              <div className="pasturemanagement__footerlegend--content">
                <div>
                  <div className="pasturemanagement--bar" />
                  <div className="pasturemanagement--containerlegend">
                    <span>0</span>
                    <span>{formatNumber(Number(maxValueOnGradiente))}</span>
                  </div>
                </div>
              </div>
              <br />
            </>
          )}
          <div className="pasturemanagement__footerlegend--content">
            <LegendRounded label="Acima da nota" bgColor={Constants.PASTUREMANAGEMENT_COLORS.GREEN} />
            <LegendRounded label="Dentro do intervalo" bgColor={Constants.PASTUREMANAGEMENT_COLORS.CYAN} />
            <LegendRounded label="Abaixo da nota" bgColor={Constants.PASTUREMANAGEMENT_COLORS.RED} />
            <LegendRounded label="Sem nota atribuida" bgColor={Constants.PASTUREMANAGEMENT_COLORS.YELLOW} />
          </div>
        </section>
      </>
    );
  }

  if (view === "day") {
    return (
      <section className="pasturemanagement__footerlegend--container">
        {maxOcupacao !== 0 && (
          <div>
            <strong className="capacitybvroute__barnumber--title">Dias de ocupação</strong>
            <div className="paddocktime__barnumber--bar1" />
            <div className="paddocktime__barnumber--containerlegend">
              <span>0</span>
              <span>{formatNumber(Number(maxOcupacao))}</span>
            </div>
          </div>
        )}
        <br />
        {maxDescanso !== 0 && (
          <div>
            <strong className="capacitybvroute__barnumber--title">Dias de descanso</strong>
            <div className="paddocktime__barnumber--bar2" />
            <div className="paddocktime__barnumber--containerlegend">
              <span>0</span>
              <span>{formatNumber(Number(maxDescanso))}</span>
            </div>
          </div>
        )}
        <br />
        <div className="pasturemanagement__footerlegend--content">
          <LegendRounded label="Acima dos dias de ocupação" bgColor={Constants.PASTUREMANAGEMENT_COLORS.RED} />
          <LegendRounded label="Abaixo dos dias de ocupação" bgColor={Constants.PASTUREMANAGEMENT_COLORS.GREEN} />
        </div>
      </section>
    );
  }

  return null;
}
